import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import frTranslations from './locales/fr/translation.json';
import arTranslations from './locales/ar/translation.json';

// تكوين موارد الترجمة
const resources = {
  fr: {
    translation: frTranslations,
  },
  ar: {
    translation: arTranslations,
  },
};

// تهيئة i18next
i18n
  .use(LanguageDetector) // الكشف عن لغة المتصفح
  .use(initReactI18next) // التكامل مع React
  .init({
    resources,
    lng: 'ar', // اللغة الافتراضية هي العربية
    fallbackLng: 'ar', // اللغة الاحتياطية هي العربية
    supportedLngs: ['ar', 'fr'], // اللغات المدعومة
    detection: {
      order: ['localStorage', 'navigator'], // ترتيب أولوية الكشف عن اللغة
      caches: ['localStorage'], // حفظ اللغة المختارة في التخزين المحلي
    },
    interpolation: {
      escapeValue: false, // لا حاجة للهروب في React
    },
  });

// إدارة تغيير اللغة واتجاه النص (RTL/LTR)
i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
  document.documentElement.setAttribute('dir', lng === 'ar' ? 'rtl' : 'ltr');
  document.body.style.textAlign = lng === 'ar' ? 'right' : 'left';
});

export default i18n;